function clearNumber(value = "") {
  return value.replace(/\D+/g, "");
}

export function formatCreditCardNumber(value: string) {
  if (!value) return value;
  const clearValue = clearNumber(value).slice(0, 19);
  return clearValue.replace(/(\d{4})(?=\d)/g, "$1 ").trim();
}

export function formatCVC(value: string, _prevValue?: string, allValues: { number?: string } = {}) {
  const clearValue = clearNumber(value);
  const issuer = allValues.number?.replace(/\s/g, "").startsWith("3") ? "amex" : "";
  const maxLength = issuer === "amex" ? 4 : 3;
  return clearValue.slice(0, maxLength);
}

export function formatExpirationDate(value: string) {
  const clearValue = clearNumber(value).slice(0, 4);
  if (clearValue.length >= 3) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
  }
  return clearValue;
}
